import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ManagersServiceProvider } from '../../api/managers'

const ManagersService = ManagersServiceProvider()
const name = 'managerMoveEmployees'

export default (managerId, targetManagerId, employeeIds, alternativeCampaignName) => {
  const data = { managerId, targetManagerId, employeeIds }
  if (alternativeCampaignName) {
    data.alternativeCampaignName = alternativeCampaignName
  }
  return asyncAction(
    name,
    ManagersService.moveEmployees,
    data
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/manager/managerMoveEmployees.js